module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-light-gray-215e4a956e3140e76b459e98033a6cbf.png";